import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';

import { InputPanel, InputPassword, InputTextBox } from '@camelot/form-model';
import { graphQlUpdateFields } from '@camelot/server';
import { getModifiedValues } from '@camelot/utils';

import {
  CalendarSyncConfiguration,
  CalendarSyncConfigurationCreationPayloadInput,
  CalendarSyncConfigurationModifierPayloadInput,
} from '../dto/calendar-sync-config';

enum ECalendarSyncConfigFormFields {
  clientTenantId = 'clientTenantId',
  clientId = 'clientId',
  clientSecret = 'clientSecret',
}

@Injectable({
  providedIn: 'root',
})
export class CamCalendarSyncConfigFormService {
  public getCalendarSyncConfigForm(calendarSyncConfig: CalendarSyncConfiguration | null) {
    return [
      new InputPanel({
        key: 'panel',
        label: 'calendar-sync-config.form.title',
        contentClass: 'highlight-title g-space-md',
        children: [
          new InputTextBox({
            key: ECalendarSyncConfigFormFields.clientId,
            value: calendarSyncConfig?.clientId,
            label: 'calendar-sync-config.form.clientId',
            validators: [Validators.required],
          }),
          new InputPassword({
            alwaysHidden: true,
            key: ECalendarSyncConfigFormFields.clientSecret,
            value: calendarSyncConfig?.clientSecret,
            label: 'calendar-sync-config.form.clientSecret',
            validators: [Validators.required],
          }),
          new InputTextBox({
            key: ECalendarSyncConfigFormFields.clientTenantId,
            value: calendarSyncConfig?.clientTenantId,
            label: 'calendar-sync-config.form.clientTenantId',
            validators: [Validators.required],
          }),
        ],
      }),
    ];
  }

  public calendarSyncConfigCreateFormatForm(data: any): CalendarSyncConfigurationCreationPayloadInput {
    return {
      clientId: data[ECalendarSyncConfigFormFields.clientId] ?? null,
      clientSecret: data[ECalendarSyncConfigFormFields.clientSecret] ?? null,
      clientTenantId: data[ECalendarSyncConfigFormFields.clientTenantId] ?? null,
    };
  }
  public calendarSyncConfigUpdateFormatForm(
    data: any,
    calendarSyncConfig: CalendarSyncConfiguration
  ): Partial<CalendarSyncConfigurationModifierPayloadInput> {
    const modifiedData = getModifiedValues(data, calendarSyncConfig);
    return {
      ...this.calendarSyncConfigCreateFormatForm(data),
      ...graphQlUpdateFields(modifiedData),
    };
  }
}
